/* @flow */
import React from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import EmailIcon from 'material-ui/svg-icons/communication/email';
import PhoneIcon from 'material-ui/svg-icons/communication/phone';
import IconButton from 'material-ui/IconButton';

import type { TutorHeader_tutor } from './__generated__/TutorHeader_tutor.graphql';

const styles = {
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
  actionButton: {
    margin: 12,
  },
};

type Props = {
  tutor: TutorHeader_tutor,
};

const TutorHeader = ({ tutor }: Props) => (
  <div>
    <div style={styles.header}>
      <form>
        <TextField
          floatingLabelText="Firstname"
          value={tutor.firstname}
          floatingLabelFixed
          readOnly
        />
        <br />
        <TextField
          floatingLabelText="Lastname"
          value={tutor.lastname}
          floatingLabelFixed
          readOnly
        />
        <br />
        <FlatButton primary>
          <a target="_blank" href={tutor.user.facebookProfileLink}>
            Open Facebook Profile
          </a>
        </FlatButton>
        <br />
        {/* <TextField
          floatingLabelText="Cell"
          value={tutor.cellphoneNumber}
          readOnly
          floatingLabelFixed
        /> */}
        {/* $FlowFixMe */}
        <IconButton tooltip="Cell" href={`tel:${tutor.cellphoneNumber}`}>
          <PhoneIcon />
        </IconButton>
        <br />
        <TextField
          floatingLabelText="Email"
          readOnly
          value={tutor.user.email}
          floatingLabelFixed
        />
        <IconButton tooltip="Email" href={`mailto:${tutor.user.email}`}>
          <EmailIcon />
        </IconButton>
        <br />
        {/* <TextField
          floatingLabelText="About Me"
          readOnly
          value={tutor.aboutMe}
          floatingLabelFixed
          multiLine
          rowsMax={6}
        /> */}
        <br />
        <TextField
          floatingLabelText="Status"
          readOnly
          value={tutor.user.status.replace('UserStatus.', '')}
          floatingLabelFixed
        />
        <br />
      </form>
      <div>
        {tutor.profilePictureUrl ? (
          <div style={{ padding: 20 }}>
            <img
              width={300}
              alt="Student Profile"
              src={tutor.profilePictureUri}
            />
          </div>
        ) : (
          <div>Image Unavailable</div>
        )}
        <TextField
          floatingLabelText="Documents"
          value={tutor.documentsCount}
          readOnly
          floatingLabelFixed
        />
      </div>
    </div>
  </div>
);

export default createFragmentContainer(TutorHeader, {
  tutor: graphql`
    fragment TutorHeader_tutor on Tutor {
      firstname
      lastname
      cellphoneNumber
      aboutMe
      profilePictureUri(size: large)
      documentsCount
      user {
        email
        status
        active
        facebookProfileLink
      }
    }
  `,
});



// WEBPACK FOOTER //
// ./src/modules/admin/tutor/components/TutorHeader.js